import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormAuftrag, BefehlFormField } from '../Generic'
import { useTranslation } from 'react-i18next'
import { Input } from '../../form'
import { useMemo } from 'react'

export interface Auftrag28_20FormProps {
  befehlKennung: string
  fieldPrefix: string
  readOnly: boolean
  'data-testid': string
  errors?: FieldErrors
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag28_20Form({
  readOnly,
  'data-testid': testId,
  errors,
  fieldPrefix,
  activateEmptyFieldWarnings = false
}: Readonly<Auftrag28_20FormProps>) {
  const formContext = useFormContext()
  const { control, formState, watch, resetField } = formContext
  const { t } = useTranslation('ui-befehle')

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  const auftrag_28_20_inactive = !watch('auftrag_28_20.enabled')

  return (
    <BefehlFormAuftrag
      auftragKennung="28.20"
      label={t('auftraege.28_20.label')}
      fieldName="auftrag_28_20.enabled"
      control={control}
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      onChange={(checked) => {
        if (!checked) {
          resetField('auftrag_28_20')
        }
      }}
    >
      <div className="@container">
        <div
          className="flex flex-col @[430px]:flex-row items-baseline gap-1"
          data-testid={`${testId}-outer-div`}
        >
          <span data-testid={`${testId}-text`}>
            {t('auftraege.28_20.label')}
          </span>
          <div className="flex flex-col">
            <BefehlFormField
              name={'auftrag_28_20.etcsBetriebsart'}
              control={control}
              label={t('auftraege.28_20.etcs_betriebsart_label')}
              readOnly={readOnly}
              activateEmptyWarning={activateEmptyFieldWarnings}
              data-testid={`${fieldPrefix}-feld-28-21`}
              render={({ field }) => (
                <Input
                  {...field}
                  name={'auftrag_28_20.etcsBetriebsart'}
                  label={t('auftraege.28_20.etcs_betriebsart_label')}
                  errors={fieldErrors}
                  disabled={auftrag_28_20_inactive}
                  className="w-full"
                  data-testid={`${testId}-feld-28-21-inner`}
                />
              )}
            ></BefehlFormField>
            <div>
              <span
                className={
                  auftrag_28_20_inactive ? 'text-gray-500 opacity-60' : ''
                }
                data-testid={`${fieldPrefix}-feld-28-21-label`}
              >
                {t('auftraege.28_20.input_label_etcs_betriebsart')}
              </span>
            </div>
          </div>
          <span data-testid={`${fieldPrefix}-text-waehlen`}>
            {t('auftraege.28_20.after_input')}
          </span>
        </div>
      </div>
    </BefehlFormAuftrag>
  )
}
